import React, { memo, useMemo, useState, useEffect, useContext } from 'react';
import { ENTITIES } from 'lib/constants';
import { useWeb5Context } from 'lib/Web5Context';
import { getTables } from 'lib/services/imports';
import SectionTabs from 'components/SectionTabs';
import { getDescription } from 'utils/custom';

import ImportContext from './../ImportContext';

const defaultTabs = [
    {
        key: ENTITIES.ACCOUNTS.importExport,
        title: 'cfm_label_accounts',
    },
    {
        key: ENTITIES.CONTACTS.importExport,
        title: 'cfm_label_contacts',
    },
    {
        key: ENTITIES.OPPORTUNITIES.importExport,
        title: 'cfm_label_opportunities',
    },
    {
        key: ENTITIES.USERS.importExport,
        title: 'cfm_label_users',
    },
    /*{
        key: ENTITIES.ACTIVITIES.importExport,
        title: 'cfm_label_activities',
    },
    {
        key: ENTITIES.CALENDAR.importExport,
        title: 'cfm_label_event_task',
    },
    {
        key: ENTITIES.SALESORDERS.importExport,
        title: 'cfm_label_salesorders',
    },
    {
        key: ENTITIES.PRODUCTS.importExport,
        title: 'cfm_label_products',
    },*/
];

const ImportsTabs = ({
    onChange,
    onChangeShrinked,
    activeTab,
    activeShrinkedTab,
    idSetupRole,
    isNotAdmin,
}) => {
    const { t, permissions: contextPermissions } = useWeb5Context();
    const { permissions: externalPermissions } = useContext(ImportContext);
    const permissions = externalPermissions || contextPermissions;
    const { permissions: rolesPermissions } = permissions;
    const [shrinkedTabs, setShrinkedTabs] = useState([]);

    const tabs = useMemo(
        () =>
            defaultTabs
                .filter((tab) => {
                    if (rolesPermissions?.editFromWeb)
                        return tab?.key !== ENTITIES.USERS.importExport;
                    else return tab;
                })
                .map(({ key, title }) => ({ key, title: t(title) })),
        [rolesPermissions?.editFromWeb, t],
    );

    const dumbUser = idSetupRole ? [8, 9].includes(idSetupRole) : false;

    useEffect(() => {
        if (isNotAdmin) return;
        getTables()
            .then(({ data }) => {
                if (!data) return;
                setShrinkedTabs(
                    data
                        .filter(
                            ({ name }) =>
                                !tabs.find((tab) => name.toLowerCase() === tab.key.toLowerCase()),
                        )
                        .map((tab) => ({
                            label: getDescription({ tab, dumbUser }),
                            value: tab.name,
                            description: tab?.description || null,
                        })),
                );
            })
            .catch(console.error);
        // setShrinkedTabs([]);
    }, [tabs, dumbUser, isNotAdmin]);

    return (
        <div id="fm-imports__tabs">
            <SectionTabs
                onChangeShrinked={!isNotAdmin ? onChangeShrinked : undefined}
                onChange={onChange}
                activeTab={activeTab}
                activeShrinkedTab={!isNotAdmin ? activeShrinkedTab : undefined}
                tabs={tabs}
                shrinkedTabs={!isNotAdmin ? shrinkedTabs : undefined}
            />
        </div>
    );
};

ImportsTabs.propTypes = {};

export default memo(ImportsTabs);
